module.exports = __webpack_public_path__ + "media/images/undraw_internet-2a526081f81b9c4e91d1622d102c350a.svg";